module.exports = __webpack_public_path__ + "img/Octans.983a80e4.png";